'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; // get all actions from redux store


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _goals = require('redux/modules/goals');

var barrierActions = _interopRequireWildcard(_goals);

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Barriers = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    profile: state.profile.data,
    goals: state.goals.data
  };
}, barrierActions), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Barriers, _Component);

  function Barriers() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Barriers);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Barriers.__proto__ || (0, _getPrototypeOf2.default)(Barriers)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isEdit: false,
      barriers: _this.props.goals.barriers || []
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj.barriers[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleRemoveBarrier = function (index) {
      var obj = _this.state;
      obj.barriers.splice(index, 1);
      _this.setState(obj);
    }, _this.handleClickEdit = function () {
      var obj = _this.state;
      obj.isEdit = !obj.isEdit;
      _this.setState(obj);
    }, _this.handleSave = function () {
      var userId = _this.props.user.userId;
      _this.props.updateBarriers(userId, _this.state);
    }, _this.handleAddBarrier = function () {
      var obj = _this.state;
      obj.barriers.push('');
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  // without handleChange, form value fields would not change on the front end


  /* User clicks on edit button */


  /* save barrier changes */


  /*
   * Adds another barrier to the front end UI
   */


  (0, _createClass3.default)(Barriers, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Profile.scss');

      return _react2.default.createElement(
        'div',
        null,
        !this.state.isEdit && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.card + ' ' + styles.cardContent },
            _react2.default.createElement(
              'h2',
              { className: styles.orangeText + ' ' + styles.textCenter },
              'My barriers'
            ),
            this.state.barriers.length === 0 && _react2.default.createElement(
              'div',
              { className: styles.textCenter },
              _react2.default.createElement(
                'h3',
                null,
                'No barriers have been set yet!'
              ),
              _react2.default.createElement(
                'h4',
                null,
                'Start working through the ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/moduleslanding' },
                  'modules'
                ),
                ' to set barriers!'
              ),
              _react2.default.createElement('div', { className: styles.spacer20 })
            ),
            this.state.barriers.map(function (barrier, index) {
              return _react2.default.createElement(
                'div',
                { key: 'barrier' + index },
                _react2.default.createElement(
                  ReactBootstrap.Row,
                  null,
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 2, sm: 2, lg: 2 },
                    _react2.default.createElement(
                      'h3',
                      null,
                      index + 1,
                      '.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Col,
                    { md: 10, sm: 10, lg: 10 },
                    _react2.default.createElement(
                      'h3',
                      null,
                      barrier
                    )
                  )
                )
              );
            }),
            this.state.barriers.length !== 0 && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                ReactBootstrap.ButtonToolbar,
                null,
                _react2.default.createElement(
                  ReactBootstrap.Button,
                  { className: 'pull-right',
                    bsStyle: 'success', onClick: this.handleClickEdit },
                  _react2.default.createElement('i', { className: 'fa fa-user-o' }),
                  '  Edit barriers'
                )
              )
            )
          )
        ),
        this.state.isEdit && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.card + ' ' + styles.cardContent },
            _react2.default.createElement(
              'h2',
              { className: styles.orangeText + ' ' + styles.textCenter },
              'My barriers'
            ),
            this.state.barriers.map(function (barrier, index) {
              return _react2.default.createElement(
                'div',
                { key: 'editbarrier' + index },
                _react2.default.createElement(
                  ReactBootstrap.InputGroup,
                  null,
                  _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text', bsSize: 'large',
                    placeholder: 'Set a barrier', onChange: _this2.handleChange.bind(_this2, index),
                    value: _this2.state.barriers[index] }),
                  _react2.default.createElement(
                    ReactBootstrap.InputGroup.Button,
                    null,
                    _react2.default.createElement(
                      ReactBootstrap.Button,
                      { bsSize: 'large', bsStyle: 'danger',
                        onClick: _this2.handleRemoveBarrier.bind(_this2, index) },
                      _react2.default.createElement('i', { className: 'fa fa-close' })
                    )
                  )
                ),
                _react2.default.createElement('br', null)
              );
            }),
            _react2.default.createElement(
              ReactBootstrap.ButtonToolbar,
              null,
              _react2.default.createElement(
                ReactBootstrap.Button,
                { bsStyle: 'success', onClick: this.handleAddBarrier },
                _react2.default.createElement('i', { className: 'fa fa-plus' }),
                '  Add barrier'
              ),
              _react2.default.createElement(
                ReactBootstrap.Button,
                { className: 'pull-right', bsStyle: 'success',
                  onClick: function onClick() {
                    _this2.handleClickEdit();_this2.handleSave();
                  } },
                _react2.default.createElement('i', { className: 'fa fa-check' }),
                '  Save'
              )
            )
          )
        )
      );
    }
  }]);
  return Barriers;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  goals: _propTypes2.default.object,
  updateBarriers: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Barriers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/Barriers.js
// module id = 1221
// module chunks = 0